import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Database } from './database';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DatabaseService {
  baseUrl: string = environment.serviceUrl;
  constructor(private httpClient: HttpClient) {
  }
  getActive(): Observable<Database[]> {
    return this.httpClient.get<Database[]>(this.baseUrl + 'api/DatabaseApi/getactivedatabases')
  }
  Get(): Observable<Database[]> {
    return this.httpClient.get<Database[]>(this.baseUrl + 'api/DatabaseApi')
  }
  GetImage(filename: string): Observable<any> {
    //return this.httpClient.post(this.baseUrl + '/api/DatabaseApi/GetIcon/' + filename, { responseType: "blob" } );
    return this.httpClient.post(this.baseUrl + 'api/DatabaseApi/GetIcon/' + filename, { observe: 'response' });
  }
  Post(formdata: FormData): Observable<any> {   
    return this.httpClient.post(this.baseUrl + 'api/DatabaseApi/add', formdata, { observe: 'response' })
  }
  Delete(database: Database) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DatabaseApi/activeordeactive', database, { headers: header, observe: 'response' })
  }
  Put(formdata: FormData): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'multipart/form-data');  
    return this.httpClient.post(this.baseUrl + 'api/DatabaseApi/Update', formdata, {  observe: 'response' })
  }


}
